import React from "react";
import { Routes, Route } from "react-router-dom";

import SpreadsheetImporter from "./interest_imports/components/main";
import Lottery from "./lottery";

const Importers: React.FC = () => (
  <Routes>
    <Route path="lottery" element={<Lottery />} />
    <Route path="waitlist" element={<SpreadsheetImporter />} />
  </Routes>
);

export default Importers;
